import { useMemo } from 'react';
import { useGetLeaseQuery } from '@/store/api';
import { selectLease, getRecurringPayments } from '../utils/leaseAutoPay';

export function useLeaseAutoPay(leaseId: number | undefined) {
  const { data, isLoading, isFetching } = useGetLeaseQuery(
    { leaseId: leaseId as number, includeTransactions: false, includePayments: true },
    { skip: !leaseId },
  );
  const recurringPayments = useMemo(
    () => getRecurringPayments(selectLease(data)),
    [data],
  );
  return {
    recurringPayments,
    hasAutoPay: recurringPayments.length > 0,
    firstAutoPay: recurringPayments[0],
    isLoading,
    isFetching,
  };
}
